import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Tech enthusiast and ardent developer with deep interest in building disruptive products and doing awesome things
with code.`}</p>
    </blockquote>
    <p>{`Passionate about exploring new technological frontiers that better our day-to-day lives.`}</p>
    <style>

    </style>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      